import React, { Component } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import differenceInYears from 'date-fns/differenceInYears';
import { es } from 'date-fns/locale';
import { parse, isValid } from 'date-fns';
import styles from './styles/age-valid-modal.scss';
import logo from '../../images/katapulk_logo.svg';
import Actions from '../../actions';

const validate = (values) => {
    const errors = {};
    if (!values.day) {
        errors.day = 'required-message';
    }

    if (!values.month) {
        errors.month = 'required-message';
    }

    if (!values.year) {
        errors.year = 'required-message';
    }

    if (values.year && values.month && values.day) {
        const parsed = parse(`${values.day}/${values.month}/${values.year}`, 'dd/MM/yyyy', new Date());

        if (!isValid(parsed)) {
            errors.day = 'is-not-valid-date';
        }
    }

    return errors;
};

const renderSelectField = ({
    input, meta: { touched, error }, children,
}) => (
    <div>
        <div className={styles.inputBox}>
            <select {...input} className={styles.formInput}>
                {children}
            </select>
        </div>
        {touched && error && <div className={styles.errorMsg}><FormattedMessage id={error} defaultMessage={error} /></div>}
    </div>
);

class AgeValidModal extends Component {
    constructor(props) {
        super(props);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
        const startYear = new Date().getFullYear() - 8;
        this.state = { days: Array.from({ length: 31 }, (_, i) => i + 1), months: Array.from({ length: 12 }, (_, i) => i + 1), years: Array.from({ length: 60 }, (_, i) => startYear - i) };
    }

    handleFormSubmit(formData) {
        if (!formData.day || !formData.month || !formData.year) {
            return;
        }
        const selectedDay = parse(`${formData.day}/${formData.month}/${formData.year}`, 'dd/MM/yyyy', new Date());
        const currentDate = new Date();
        const years = differenceInYears(currentDate, selectedDay);
        const ageValid = years >= 21;

        if (this.props.user.id) {
            this.props.setAgeValid(ageValid, this.props.access_token, this.props.locale.currentLocale);
        } else {
            this.props.setAnonymousUserAgeValid(ageValid);
        }

        this.props.onHide();
    }

    render() {
        const {
            handleSubmit, valid, submitting, pristine,
        } = this.props;

        return (
            <Modal
                onHide={this.props.onHide}
                show={this.props.show}
                aria-labelledby="contained-modal-title-lg"
            >
                <form onSubmit={handleSubmit(this.handleFormSubmit)}>
                    <Modal.Body className={styles.modalBody}>

                        <div className="row">
                            <div className="col-md-12 text-center">
                                <img src={logo} alt="Logo" className={styles.logo} />
                            </div>
                        </div>

                        <div className="row margin-top-20">
                            <div className="col-md-12 text-center">
                                <div className={styles.title}>
                                    <FormattedMessage id="certify-age-title-1-message" defaultMessage="Hello, product with" />
                                </div>

                                <div className={styles.title}>
                                    <FormattedMessage id="certify-age-title-2-message" defaultMessage="age restriction?" />
                                </div>

                                <p className={styles.textInfo}>
                                    <FormattedMessage id="certify-age-enter-birthday" defaultMessage="Please enter your date of birth:" />
                                </p>
                            </div>
                        </div>

                        <div className={`row ${styles.fieldsContainer}`}>
                            <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                                <Field
                                    name="day"
                                    component={renderSelectField}
                                    locale={this.props.currentLocale}
                                >
                                    <option value="" disabled>DD</option>
                                    {this.state.days.map((day) => <option key={day} value={day}>{day}</option>)}
                                </Field>
                            </div>
                            <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                                <Field
                                    name="month"
                                    component={renderSelectField}
                                >
                                    <option value="" disabled>MM</option>
                                    {this.state.months.map((month) => <option key={month} value={month}>{month}</option>)}
                                </Field>
                            </div>
                            <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                                <Field
                                    name="year"
                                    component={renderSelectField}
                                >
                                    <option value="" disabled>YYYY</option>
                                    {this.state.years.map((year) => <option key={year} value={year}>{year}</option>)}
                                </Field>
                            </div>
                        </div>

                        <div className="row margin-top-20">
                            <div className="col-md-12 margin-top-20 text-center">
                                <button className={`form-control btn btn-default ${styles.button}`} type="submit" disabled={submitting}>
                                    <span>
                                        <FormattedMessage id="valid-age-enter" defaultMessage="Enter" />
                                    </span>
                                </button>

                                <p className={`${styles.textInfo} ${styles.textInfoSmall}`}>
                                    <FormattedMessage id="certify-age-message" defaultMessage="Upon entering I am certifying that I am really over 21 years of age." />
                                </p>
                            </div>
                        </div>
                    </Modal.Body>
                </form>
            </Modal>
        );
    }
}

const AgeValidModalForm = reduxForm({
    form: 'age-min-form', // a unique identifier for this form
    validate,
})(AgeValidModal);

const AgeValidModalConnector = connect((state) => ({
    anonymousUser: state.anonymousUser,
    user: state.user,
    access_token: state.auth.access_token,
    initialValues: {},
    locale: state.locale,
}), (dispatch) => ({
    setAnonymousUserAgeValid: (ageValid) => {
        dispatch(Actions.setAnonymousUserAgeValid({ age_valid: ageValid }));
    },
    setAgeValid: (validAge, accessToken, locale) => {
        dispatch(Actions.setAgeValid(validAge, accessToken, locale));
    },
}))(AgeValidModalForm);

export default AgeValidModalConnector;



/** WEBPACK FOOTER **
 ** ./src/components/age-valid-wrapper/age-valid-modal.jsx
 **/